/**
 * ttx.git — Build-time git version info.
 *
 * At rollup build time, placeholders below are replaced with live git info from
 * the repository (see rollup.config.js → inline "git-info" plugin).
 *
 * Other projects can also register their own version info via ttx.git.register()
 * so that all version fingerprints are discoverable from one place.
 */
window.ttx = window.ttx || {};
ttx.git = ttx.git || {};

// ── Placeholders replaced by rollup.config.js at build time ──────────────────
// When git is unavailable, they remain as-is and available=false.
var BUILD_INFO = {
  hash:       '__GIT_HASH__',
  shortHash:  '__GIT_SHORT_HASH__',
  branch:     '__GIT_BRANCH__',
  author:     '__GIT_AUTHOR__',
  date:       '__GIT_DATE__',
  subject:    '__GIT_SUBJECT__',
  dirty:      '__GIT_DIRTY__' === 'true',
  available:  '__GIT_HASH__'.length === 40,
  name:       '@xkki/utils',
  version:    '__PKG_VERSION__'
};

// Registry for version info contributed by dependent projects at runtime.
var _registry = {};

/**
 * Return a copy of the SDK's own build-time git info.
 */
ttx.git.getInfo = function () {
  // Return a shallow copy so callers cannot mutate BUILD_INFO.
  var copy = {};
  for (var k in BUILD_INFO) {
    if (Object.prototype.hasOwnProperty.call(BUILD_INFO, k)) {
      copy[k] = BUILD_INFO[k];
    }
  }
  return copy;
};

/**
 * Register version info from another module or project.
 * @param {string} name  — e.g. '@xkk/core'
 * @param {object} info  — plain object with at least { hash, branch, date, version }
 */
ttx.git.register = function (name, info) {
  if (!name || !info) return;
  _registry[name] = info;
};

/**
 * Return the full registry of all registered version info.
 */
ttx.git.getRegistry = function () {
  var copy = {};
  for (var k in _registry) {
    if (Object.prototype.hasOwnProperty.call(_registry, k)) {
      copy[k] = _registry[k];
    }
  }
  return copy;
};

/**
 * Print a styled banner for a single version entry.
 * @param {object} entry — { name, version, branch, shortHash, dirty, date, subject, author }
 * @param {string} [label] — optional label to replace entry.name in the banner
 */
function _printBanner(entry, label) {
  if (!entry || !entry.available) return;
  if (typeof window === 'undefined' || !window.console) return;

  var title = label || entry.name || 'unknown';
  var dirtyTag = entry.dirty ? ' (dirty)' : '';
  var text = '%c 【' + title + '】 %c 【' + entry.branch + ' @ ' + entry.shortHash + dirtyTag + ' · ' + entry.subject + ' · ' + entry.author + ' · ' + (entry.date ? entry.date.slice(0, 10) : '') + '】';
  var styleA = 'background:#165dff;color:#fff;padding:2px 8px;border-radius:3px 0 0 3px;font-weight:600';

  // Use window.console to survive Terser's drop_console in production builds
  // that don't explicitly exempt version output.
  window.console.warn(text, styleA, '');
}

/**
 * Print the SDK banner (and optionally all registered entries).
 */
ttx.git.printBanner = function () {
  _printBanner(BUILD_INFO);
};

/**
 * Print banners for all registered projects.
 */
ttx.git.printAll = function () {
  _printBanner(BUILD_INFO);
  for (var name in _registry) {
    if (Object.prototype.hasOwnProperty.call(_registry, name)) {
      _printBanner(_registry[name], name);
    }
  }
};